/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {EditAttributes, FlagOutlined, Layers, LinkOutlined, TipsAndUpdates} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ESTADOSCOLECCIONES} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";


const Formulario_Colecciones = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Estado y Temporada</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSCOLECCIONES.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={TipsAndUpdates} nombre={'Actual'} dato={'actual'} {...props}
                                   opciones={['Si', "No"]}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Imagen de carga ( 1920 x 1080 ) peso maximo 350kb </Typography>
                </Grid>


                <Grid container size={12}>
                    <IngresoImagenCrop alto={9} ancho={16}
                                       dato={'img'} {...props}

                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={Layers} nombre={'Nombre de la coleccion'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Descripcion de la coleccion'}
                                  dato={'descripcion'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={EditAttributes} nombre={'Nombre Boton'}
                                  dato={'nombreBoton'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={LinkOutlined} nombre={'Link Boton'}
                                  dato={'nombreBoton'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Colecciones